<div
	class="fixed inset-0 flex items-center justify-center bg-peps-dark-700 flex-col gap-8"
	[style.z-index]="zIndex"
>
	<div class="loader relative inline-grid w-20 h-20">
		<img src="/assets/images/team_peps_logo.avif" class="icon" alt="Loader icon" />
		<img src="/assets/images/team_peps_logo.avif" class="icon animated" alt="Animated loader" />
	</div>
</div>
